import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './SideBar.module.css';

const MenuItem = ({ item, isOpen, onClick }) => {
    const location = useLocation();

    return (
        <Link
            to={item.path}
            className={`${styles.navItem} ${location.pathname === item.path ? styles.active : ''}`}
            title={!isOpen ? item.label : ''}
            onClick={onClick}
        >
            <span className={styles.navIconWrapper}>
                <item.icon className={styles.navIcon} />
            </span>
            {isOpen && (
                <>
                    <div className={styles.navItemContent}>
                        <span className={styles.navLabel}>{item.label}</span>
                        {item.description && (
                            <span className={styles.navDescription}>{item.description}</span>
                        )}
                    </div>
                    {item.badge && (
                        <span className={styles.badgeNew}>{item.badge}</span>
                    )}
                </>
            )}
        </Link>
    );
};

export default MenuItem;